import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { fr } from 'vuetify/es5/locale'
import metier from '@/config/metiers'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: metier.theme.primary,
        secondary: metier.theme.secondary,
        accent: '#0050b3',
        error: '#f5222d',
        info: '#2f54eb',
        success: '#52c41a',
        warning: '#fa8c16'
      }
    },
    lang: {
      locales: { fr },
      current: 'fr'
    }
  }
})
